export const MARKET_TYPES = [
  { label: "Equity · US (NASDAQ/NYSE)", exchange: "US", asset_type: "equity" },
  { label: "Index (US / Global)", exchange: "", asset_type: "index" },
  { label: "Commodity / Metals", exchange: "COMEX", asset_type: "commodity" },
  { label: "Currency / Forex", exchange: "FOREX", asset_type: "forex" },
  { label: "Crypto", exchange: "CRYPTO", asset_type: "crypto" },
  { label: "Equity · NSE (India)", exchange: "NSE", asset_type: "equity" },
  { label: "Equity · BSE (India)", exchange: "BSE", asset_type: "equity" },
];

export function assetFromQuoteType(t) {
  const map = {
    EQUITY: "equity", INDEX: "index", CURRENCY: "forex",
    CRYPTOCURRENCY: "crypto", FUTURE: "commodity", ETF: "equity",
  };
  return map[(t || "").toUpperCase()] || "equity";
}
